/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {Injectable} from '@angular/core';
import {Observable, Subject} from 'rxjs';
import {ClaimPositionDataModel} from '../../../models/claim-position-data.model';
import {MaterialPositionTableItemModel} from '../material-position-table-item.model';
import {ClaimPositionDetailModel} from '../../../../api/ms-claims/contracts/claim-position-detail.model';

@Injectable({
    providedIn: 'root'
})
export class MaterialPositionTableService {
    private positionDataSubject = new Subject<ClaimPositionDetailModel[]>();

    get positionData(): Observable<ClaimPositionDetailModel[]> {
        return this.positionDataSubject.asObservable();
    }

    refreshPositionData(positionDetail: ClaimPositionDetailModel[]): void {
        this.positionDataSubject.next(positionDetail);
    }

    refreshPositionTableItemData(positionItems: MaterialPositionTableItemModel[]): void {
        this.positionDataSubject.next(positionItems.map((items) => items.detail));
    }

}
